import React from 'react';
import GloriousShop from '../assets/img/banner/Glorious-Evidence-shop.png'
import WhatsappButton from '../component/WhatsappButton';

const AboutUsContents = () => {
  return (
    <>   <div className="container text-[#666666]">
    <h1 className="title font-semibold">Glorious Evidence Limited</h1>
    
    <div className="grid">
      <div className="card">
        <h2>Our Passion</h2>
        <p>At Glorious Evidence Limited, we are passionate about empowering beauty professionals to build thriving businesses. We specialize in providing premium salon and spa equipment, designed to combine style, functionality, and durability. Whether sourced from top international manufacturers or crafted as custom-made solutions, our products are tailored to meet the highest standards and suit the needs of your business and clientele.</p>
      </div>

      <div className="card">
        <h2>Dedicated to Your Success</h2>
        <p>Our expert customer support team is here to assist you Monday to Saturday, 8:30 AM - 7:00 PM. Whether you're equipping a brand-new salon, upgrading your spa, or purchasing a single piece of equipment, you'll receive personalized guidance to ensure your experience is smooth and rewarding.</p>
      </div>

      <div className="card">
        <h2>Explore Nigeria's Largest Showroom</h2>
        <p>Located at 48 Bode Thomas Street, Opposite Eko Club, Surulere, Lagos, our expansive showroom offers the largest display of salon and spa equipment in the region. We invite you to visit and experience our products firsthand, compare options, and make informed decisions for your business needs.</p>
      </div>


      <div className="card">
        <h2>Ongoing Support for Your Business</h2>
        <p>Our commitment doesn't end after you purchase. With years of industry expertise, we offer post-sales support, including guidance on equipment installation, repairs, and maintenance, ensuring your tools stay in optimal condition.</p>
      </div>
      
      <div className="card">
        <h2>Custom Solutions, Inventory, and Delivery You Can Count On</h2>
        <p>At Glorious Evidence Limited, we provide:</p>
        <ul>
          <li className='list-disc ml-[1.3rem] text-red-500 italic'><span className='font-semibold text-black'>Tailored Equipment Designs:</span> For custom designs, please send your inspos or pictures at least 2 months early to allow for importation delays and manufacturing process.</li>
          <li className='list-disc ml-[1.3rem]'><span className='font-semibold'>In-Stock Options:</span> A wide range of equipment ready for immediate delivery or pickup from our Surulere showroom.</li>
          <li className='list-disc ml-[1.3rem]'><span className='font-semibold'>Reliable Logistics:</span> Fast and efficient delivery services to keep your business running without delays.</li>
        </ul>
      </div>


      <div className="card">
        <h2>Why Choose Glorious Evidence Limited?</h2>
        <div className="scrollable -ml-4">
          <ul className='ml-[1.2rem]'> 
            <li className='list-disc ml-[1.3rem]'><span className='font-semibold'>Global Standards:</span> We partner with renowned foreign manufacturers to deliver products that meet international quality benchmarks.</li>
            <li className='list-disc ml-[1.3rem]'><span className='font-semibold'>Innovation in Design:</span> We offer bespoke equipment solutions that merge practicality with aesthetic appeal.</li>
            <li className='list-disc ml-[1.3rem]'><span className='font-semibold'>Expert Guidance:</span> Our experienced team is always available to provide advice and support.</li>
            <li className='list-disc ml-[1.3rem]'><span className='font-semibold'>Commitment to Growth:</span> We continually expand our product range to keep pace with the evolving beauty and wellness industry.</li>
          </ul>
        </div>
      </div>

      <div className="card full-width">
        <p><span className='text-black font-semibold italic'>Ready to take your salon or spa to the next level? </span>  Visit us at 48 Bode Thomas Street, Opposite Eko Club, Surulere, Lagos, or reach out to us today. Together, we can help you create extraordinary spaces that redefine beauty and wellness in Nigeria.</p>
      </div>

      <div className="card full-width">
          <img src={GloriousShop} alt="Gloriou Evidence shop pic" className='bg-cover w-full ' />
      </div>
    </div>

    <style jsx>{`
      .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 20px;
      }
      .title {
        font-size: 2.5rem;
        text-align: center;
        margin-bottom: 2rem;
      }
     .grid {
display: grid;
gap: 20px;
grid-template-columns: 1fr; /* Ensure single column on small screens */
}

      .card {
        background-color: #f8f8f8;
        border-radius: 8px;
        padding: 20px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      .full-width {
        grid-column: 1 / -1;
      }
      h2 {
        font-size: 1.5rem;
        margin-bottom: 1rem;
      }
      p, ul {
        margin-bottom: 1rem;
      }
      ul li{
         color: var(--text-gray-color);
          font-family: var(--open-sans);
      }
      .scrollable {
        max-height: 200px;
        overflow-y: auto;
      }
     @media (min-width: 768px) {
.grid {
  grid-template-columns: repeat(2, 1fr);
}
}

@media (min-width: 1024px) {
.grid {
  grid-template-columns: repeat(2, 1fr); 
}
}

    `}</style>
  </div>
    <WhatsappButton />
    </>
 
      
  );
};

export default AboutUsContents;
